export const getZendeskSupportUrl = (_locale: string): string => {
  return "https://groversupportpartner.zendesk.com/";
};

export const getLocalCSPhoneNumber = (store: string): string => {
  switch (store) {
    case "de":
      return "+49 30 229 57955";
    case "at":
      return "+43 720 080870";
    default:
      return "+49 30 229 57955";
  }
};
